import Hashids from 'hashids';

// 1. Define the parameters once, centrally.
const SECRET_SALT = 'your_secret_salt'; // REPLACE THIS WITH A REAL, LONG SECRET STRING!
const MIN_LENGTH = 8;

// 2. Instantiate Hashids once using the central parameters.
const hashids = new Hashids(SECRET_SALT, MIN_LENGTH);

/**
 * Encodes an integer ID into a masked Hashid string.
 * @param {number} id - The original integer ID (e.g., 42).
 * @returns {string} The masked string ID (e.g., "XF03sR4").
 */
export const encodeId = (id) => {
    // Ensure the ID is a number before encoding
    if (typeof id !== 'number' || !Number.isInteger(id)) {
        console.error("Invalid ID provided for encoding. Must be an integer.");
        return null;
    }
    return hashids.encode(id);
};

/**
 * Decodes a Hashid string back into the original integer ID.
 * @param {string} maskedId - The masked Hashid string (e.g., "XF03sR4").
 * @returns {number | null} The original integer ID (e.g., 42), or null if decoding fails.
 */
export const decodeId = (maskedId) => {
    if (!maskedId) {
        return null;
    }

    // decode returns an array of numbers
    const decodedArray = hashids.decode(maskedId);

    if (decodedArray.length > 0) {
        // We only encoded one ID, so we return the first element.
        return decodedArray[0];
    }

    // Return null or throw an error if the decoding failed (e.g., bad salt or format)
    return null;
};